import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';


import { ConfigServerService, CustomHttp } from '../../../../../core';
import { IntegrationRepresentante } from '../integration-representante';

@Injectable({
    providedIn: 'root'
})
export class IntegrationRepresentanteHttpService {
    private pathApi: string;

    constructor(configServerService: ConfigServerService,
                private customHttp: CustomHttp) {
        this.pathApi = `${configServerService.getPathApiIntegration()}/representante`;
    }

    /** Executa a integração de leitura dos representantes com os sistemas ERP's */
    execReadIntegration(entity: IntegrationRepresentante): Observable<string> {
        // Params
        let params = new HttpParams();
        if (entity) {
            params = entity.createParams(params);
        }

        return this.customHttp.post<string>(this.pathApi, null, {params, responseType: 'text'});
    }

    /** Executa a integração de leitura individual dos dados do representante informado no ERP */
    execReadIndividualIntegration(id: number): Observable<string> {
        return this.customHttp.post<string>(`${this.pathApi}/individual/${id}`, null, {responseType: 'text'});
    }
}
